export default "__VITE_ASSET__ae40d0f9__"